import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_CANDIDATEFILTER, REACT_APP_JOB, REACT_APP_RECRUITER , REACT_APP_CUSTOMER } from "../../utils/common"

export async function getFilteredCandidates(body: any){
    const Details = postAPI(`https://search-ellow-test-domain-idre2gbljizarsx72j32ce5lre.ap-south-1.es.amazonaws.com/stage-resources/_search`, body)
    return Details
}

// export async function getSearchCandidates(value: string){
//     const Details = getAWSAPI(`https://search-ellow-test-domain-idre2gbljizarsx72j32ce5lre.ap-south-1.es.amazonaws.com/qa-resources/_search?q=${value}&pretty=true` )
//     return Details
// }

export async function postCandidateToJob(body: any) {
    const Details = postAPI( REACT_APP_JOB + '/candidate-position', body)
    return Details

}

export async function getCandidates(tabName: string,  pageSize: number, pageNumber: number, searchValue: string, body?: any){
    const Details = postAPI(REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, body)
    return Details
}


export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getProviderResources(){    
    const Details = getAPI( REACT_APP_CUSTOMER + '/getProviderResources')
    return Details
  }
  
  export async function getRecruiterResources(){
    const Details = getAPI( REACT_APP_RECRUITER + '/list')
    return Details
  }
  